export const dateTimeFormats = {
  "hu-HU": {
    day: {
      day: "2-digit",
    },
    numericDate: {
      // 2022. 05. 07.
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "Europe/Budapest",
    },
    shortDate: {
      // 2022. máj. 31.
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "Europe/Budapest",
    },
    shortDateTime: {
      // 2022. máj. 31. 22:54
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Budapest",
    },
    longDate: {
      // 2022. május 31.
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "Europe/Budapest",
    },
    longDateTime: {
      // 2022. május 31. 22:54
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Budapest",
    },
    weekdayTime: {
      // kedd 22:54
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
    },
    dayOf: {
      // 2022. május 31. 22:54  -> 31
      day: "numeric",
    },
    numericDateTime: {
      // 2023. 11. 21. 17:18
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  "cs-CZ": {
    day: {
      day: "2-digit",
    },
    numericDate: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "Europe/Prague",
    },
    shortDate: {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "Europe/Prague",
    },
    shortDateTime: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Prague",
    },
    longDate: {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "Europe/Prague",
    },
    longDateTime: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Prague",
    },
    weekdayTime: {
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
    },
    dayOf: {
      day: "numeric",
    },
    numericDateTime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  "de-DE": {
    day: {
      day: "2-digit",
    },
    numericDate: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "Europe/Berlin",
    },
    shortDate: {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "Europe/Berlin",
    },
    shortDateTime: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Berlin",
    },
    longDate: {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "Europe/Berlin",
    },
    longDateTime: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Berlin",
    },
    weekdayTime: {
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
    },
    dayOf: {
      day: "numeric",
    },
    numericDateTime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
  "pl-PL": {
    day: {
      day: "2-digit",
    },
    numericDate: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: "Europe/Warsaw",
    },
    shortDate: {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "Europe/Warsaw",
    },
    shortDateTime: {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Warsaw",
    },
    longDate: {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "Europe/Warsaw",
    },
    longDateTime: {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZone: "Europe/Warsaw",
    },
    weekdayTime: {
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
    },
    dayOf: {
      day: "numeric",
    },
    numericDateTime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
};

export const numberFormats = {
  "hu-HU": {
    integer: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    currency: {
      style: "currency",
      currency: "HUF",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    rating: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    },
    decimal: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  "cs-CZ": {
    integer: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    currency: {
      style: "currency",
      currency: "CZK",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    rating: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    },
    decimal: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  "de-DE": {
    integer: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    currency: {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    rating: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    },
    decimal: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  "hr-HR": {
    integer: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    currency: {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    rating: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    },
    decimal: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  "en-US": {
    integer: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    currency: {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    rating: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    },
    decimal: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  "pl-PL": {
    integer: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    currency: {
      style: "currency",
      currency: "PLN",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
    rating: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    percent: {
      style: "percent",
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    },
    decimal: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
};
